const year = new Date().getFullYear();

const Footer = () => (
    <footer className="bg-gray-800 w-full text-center py-4 px-4">
        <p className="font-semibold text-sm tracking-tight text-gray-200">
            T.ELEC — Électricien à Nancy et alentours — Copyright © {year}
        </p>
    </footer>
);

export default Footer;